import { createFileRoute } from '@tanstack/react-router';

import { client } from '@@api/client';
import { serializeTagColumnId } from '@@api/services/placement/columnIds';
import { handleLoaderError } from '@@router/handleLoaderError';

// The tag and its page, for the modals that add a section to it or edit one of its sections
export const Route = createFileRoute('/_authenticated/placement/$tenantId/tag/$tagId/sections')({
    context: ({ params }) => ({
        tagQuery: client.metadata.tags.get.queryOptions({ params: { id: Number(params.tagId) } }),
        tagPageQuery: client.placement.tagPage.get.queryOptions({
            params: { id: serializeTagColumnId(Number(params.tenantId), Number(params.tagId)) },
        }),
    }),
    loader: ({ context }) =>
        Promise.all([
            context.queryClient.query({ ...context.tagQuery, staleTime: 'static' }),
            context.queryClient.query({ ...context.tagPageQuery, staleTime: 'static' }),
        ]).catch(handleLoaderError),
});
